module.exports = __webpack_public_path__ + "img/storeIconMenu.75360285.svg";